<template lang="pug">
  v-input(v-bind="$attrs")
    v-sheet(
      :class="stylesClass"
      color="grey lighten-5"
    ).sdo-radius.pa-5.mb-4.direction-acitivity.fill-width
      .image
        .direction-content__icon
      .direction-acitivity__inputs
        strong.py-5 Вид курса
        select-direction(
          v-model="direction"
          hide-details
        ).mt-5.mb-3
        select-activity(
          v-if="direction"
          :value="value.type_activity"
          :direction-id="direction"
          hide-details
          @input="update('type_activity', $event)"
        )
</template>

<script>
import SelectDirection from './SelectDirection.vue';
import SelectActivity from './SelectActivity.vue';

export default {
  components: {
    SelectDirection,
    SelectActivity,
  },
  props: {
    value: {
      type: Object,
      default: () => ({
        direction: null,
        type_activity: null,
      }),
    },
  },
  data: () => ({
    direction: null,
  }),
  computed: {
    stylesClass() {
      let cssClass;
      switch (this.direction) {
        case 1: cssClass = 'direction-robo'; break;
        case 2: cssClass = 'direction-tech'; break;
        case 3: cssClass = 'direction-art'; break;
        case 4: cssClass = 'direction-natural-science'; break;
        case 5: cssClass = 'direction-social'; break;
        case 6: cssClass = 'direction-tourism'; break;
        case 7: cssClass = 'direction-sport'; break;
        default: cssClass = 'direction-art'; break;
      }
      return cssClass;
    },
  },
  created() {
    this.direction = this.value.direction;
  },
  methods: {
    update(key, value) {
      return this.$emit('input', { direction: this.direction, [key]: value });
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "~@/styles/views/directions.scss";

  .direction-acitivity {
    position: relative;
    overflow: hidden;

    &__inputs {
      padding-left: 150px;
    }

    .direction-content__icon {
      @media (max-height: 768px) {
        display: none;
      }
      width: 100%;
      height: 100%;
      overflow: hidden;
      bottom: 0;
      left: 0;
      position: absolute;
      z-index: 1;

      &:after {
        content: "";
        opacity: 1;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 1;
        background-position: center;
        background-size: contain;
      }
    }

    .image {
      position: absolute;
      top: 0;
      left: 0;
      background-size: cover;
      background-position-x: 90%;
      width: 150px;
      height: 100%;

      &:before {
        content: '';
        position: absolute;
        background-color: rgba(0,0,0, .5);
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
      }
    }
  }
</style>
